export const SOLAPULSE_API = '/json/solapulse/survey';
export const COOKIE_SURVEY_ANSWERED = 'Survey1Answered';
